import { Fragment, useEffect, useRef, useState } from "react";
import "leaflet/dist/leaflet.css";
import { getServiceLines, clearComponentData, getStarlinkLastLocation } from "../StarlinkDashboard/slice";
import CircleIcon from '@mui/icons-material/Circle';
import { withRouter } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import SortArrows, { SortOrder } from "../SortArrows";
import { getDecodeURI, getEncodedURI, getSource, getUsageSource, getDataFromLocalStorageParsed, middleEllipsis, middleEllipsisByWidth } from '../../utils/util';
import moment from "moment-timezone";
import CallSplitIcon from '@mui/icons-material/CallSplit';
import { TableContainer, TableHead, Table, TableRow, Paper, TableCell, TableBody, Tooltip, IconButton, Grid, Box, LinearProgress, Typography, Switch } from "@mui/material";
import { STARLINK_DATAUSAGE_CATEGORIES } from "../../UserScreen/Starlink/types";
import { Pagination } from "../StarlinkPagination";
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import StarlinkMap from "./StarlinkMap";
import _ from "lodash";
import DownloadCSV, { clearCsvDownload } from "../DownloadCSV";
import { CsvParameters, downloadAsCSV } from "../../actions/Users/authenticateCsvDownload";
import { alertMap, titleCase, defaultFilters } from "../../utils/constants";
import { getNonAdminPermissions, getValidDPOs} from "../StarlinkAdmin/slice";
import TopUpModal from "../../UserScreen/InventoryPage/InventorySettings/components/Modals/TopUpModal";
import TopBar from "../CommonComponents/TopBar";
import "../StarlinkDashboard/StarlinkDashboard.css"
import Warning from "../../asset/image/warning_blue.svg"
import OptedIn from "../../asset/image/opted_in.svg"
import OptedOut from "../../asset/image/opted_out.svg"
import TerminalIcon from "../../asset/image/terminal_icon.svg";
import TerminalIconOffline from "../../asset/image/terminal_icon_offline.svg";
import TopupEnabledIcon from "../../asset/image/topup_enabled_icon.svg";
import starlinkAddNew from "../../asset/image/addSymbol.svg"

export type DashboardSortBy = 'nickname' | 'accountDpName' | 'dpName' | 'usageGB' | 'kitSerialNumber' | 'activeAlerts' | 'k4SiteName' | 'online';

const Card = (props) => {
  const { title, leftTitle, leftContent, rightTitle, rightContent, progress } = props;
  return (
    <Paper classes={{ root: 'starlink--base--flex--column starlink--base--flex--justify--space_between starlink--base--padding_05x' }}>
      <Typography component="div" className="starlink--dashboard--card_title">
        {title}
      </Typography>
      <Grid classes={{ root: 'starlink--base--flex--row starlink--base--flex--justify--space_around starlink--base--mtb_07x' }}>
        <Grid>
          <Typography component="div" classes={{ root: 'starlink--base--font_08x starlink--base--text_center' }}>
            {leftTitle}
          </Typography>
          <Typography component="div" classes={{ root: 'starlink--base--font_1x starlink--base--text_center' }}>
            {leftContent}
          </Typography>
        </Grid>
        <Grid>
          <Typography component="div" classes={{ root: 'starlink--base--font_08x starlink--base--text_center' }}>
            {rightTitle}
          </Typography>
          <Typography component="div" classes={{ root: 'starlink--base--font_1x starlink--base--text_center' }}>
            {rightContent}
          </Typography>
        </Grid>

      </Grid>
      <Box className="starlink--dashboard--card_progress">
        <LinearProgress variant="determinate" value={progress} />
      </Box>
    </Paper>
  )
}

const StarlinkMapsDashboard = (props) => {
  const { location, history, authReducer, dpIds, newSummaryStartDate, newSummaryEndDate, getValidDPOs, selectedOu, isValidDpForDPO, newSummaryServiceLine, hasUserChangedServiceLine, getSubscribedServiceLines, selectedServiceAccount, newSummaryServiceAccount, clearComponentData, serviceLines, getServiceLines, getStarlinkLastLocation, starlinkLastLocations, downloadAsCSV } = props
  const queryParams = new Map<string, string>(Object.entries(getDecodeURI(location.search)));
  const [selectedServiceLine, setSelectedServiceLine] = useState<any>(null)
  const [hoveredSL, setHoveredSL] = useState<any>(null)
  const [mapClick, setMapClick] = useState<any>(null)
  const dispatch = useDispatch();
  const [switchServiceLineToggle, setSwitchServiceLineToggle] = useState(false)
  const [searchOperation, setSearchOperation] = useState(false)
  const [searchText, setSearchText] = useState<any>(queryParams.get('search') || '');
  const searchTimeoutRef = useRef<any>();
  const [filters, setFilters] = useState([...defaultFilters]);
  const [selectedFilters, setSelectedFilters] = useState<any>([...defaultFilters?.filter(filter => filter.selected)]);
  const [openCard, setOpenCards] = useState(false)
  const counts = serviceLines?.[0] || {};
  const [openTopUp, setOpenTopUp] = useState<{ open: boolean, data: any | null }>({ open: Boolean(new URLSearchParams(window.location.search).get('TransactionToken')), data: null })  
  const isAllServiceLineUser =  getDataFromLocalStorageParsed("loggedInUser")?.data?.user?.allServiceLineUser
  const {
    totalCount: totalServiceLines = 0,
    totalUsageGB = 0,
    totalOverageGB = 0,
    totalUserTerminals = 0,
    totalOnlineTerminals = 0,
    totalActiveAlerts = 0,
    totalAlertingTerminals = 0,
    totalOverage = 0
  } = counts;

  const [tableParams, setTableParams] = useState<{
    page: number;
    size: number;
    sortBy: DashboardSortBy;
    sortOrder: SortOrder;
    search: string;
    startDate: moment.Moment;
    endDate: moment.Moment;
  }>({
    page: queryParams.get('page') ? Number(queryParams.get('page')) : 1,
    size:  25,
    sortBy: queryParams.get('sortBy') as DashboardSortBy || 'usageGB',
    sortOrder: queryParams.get('sortOrder') as SortOrder || 'desc',
    search: queryParams.get('search') || '',
    startDate: newSummaryStartDate,
    endDate: newSummaryEndDate
  });

  const updateQueryParams = () => {
    queryParams.set('page', tableParams.page.toString())
    queryParams.set('size', tableParams.size.toString())
    queryParams.set('sortBy', tableParams.sortBy)
    queryParams.set('sortOrder', tableParams.sortOrder)
    queryParams.set('search', tableParams.search)
    history.replace({ pathname: location.pathname, search: `?${getEncodedURI(Object.fromEntries(queryParams.entries()))}` });
  }

  useEffect(() => {
    if (tableParams.startDate.format('YYYY-MM-DD') == newSummaryStartDate.format('YYYY-MM-DD') && tableParams.endDate.isSame(newSummaryEndDate)) {
        return;
    }
    setTableParams({
        ...tableParams,
        startDate: newSummaryStartDate,
        endDate: newSummaryEndDate,
        page: 1
    });
}, [newSummaryEndDate, newSummaryStartDate])

  const processFilters = (filters) => {
    const filterStates = {
      offlineServiceLines: false,
      onlineServiceLines: false,
      noTerminals: false,
      offlineTerminals: false,
      alertingTerminals: false,
      onlineTerminals: false,
      mobilePriorityEnabled: false,
      mobilePriorityDisabled: false,
    };
    filters?.forEach((filter) => {
      switch (filter.label) {
        case "onlineServiceLineStatus":
          filterStates.onlineServiceLines = true;
          break;
        case "offlineServiceLineStatus":
          filterStates.offlineServiceLines = true;
          break;
        case "noTerminals":
          filterStates.noTerminals = true;
          break;
        case "offlineTerminals":
          filterStates.offlineTerminals = true;
          break;
        case "alertingTerminals":
          filterStates.alertingTerminals = true;
          break;
        case "onlineTerminals":
          filterStates.onlineTerminals = true;
          break;
        case "mobilePriorityEnabled":
          filterStates.mobilePriorityEnabled = true;
          break;
        case "mobilePriorityDisabled":
          filterStates.mobilePriorityDisabled = true;
          break;
        default:
          break;
      }
    });
    return filterStates;
  };

  const [effectiveServiceLines, setEffectiveServiceLines] = useState<any[] | "''" | null>(null);

  useEffect(() => {
  if (isAllServiceLineUser && !hasUserChangedServiceLine) {
    setEffectiveServiceLines("''"); 
    return;
  }

  if (isAllServiceLineUser && hasUserChangedServiceLine) {
    if (Array.isArray(newSummaryServiceLine) && newSummaryServiceLine.length > 0) {
      setEffectiveServiceLines(newSummaryServiceLine);
    }
    return;
  }

  if (Array.isArray(newSummaryServiceLine) && newSummaryServiceLine?.length > 0) {
    setEffectiveServiceLines(newSummaryServiceLine);
  }
  
}, [
  isAllServiceLineUser,
  JSON.stringify(newSummaryServiceLine),
]);


useEffect(() => {
  if (_.isEmpty(tableParams)) return;
  if (effectiveServiceLines === null) return;
  const filterStates = processFilters(selectedFilters);

  const _parameters = {
    accounts:  effectiveServiceLines === "''" && newSummaryServiceAccount?.length === selectedServiceAccount?.length ? []: selectedServiceAccount,
    dpIds,
    startDate: tableParams.startDate.format("YYYY-MM-DD HH:mm:ss"),
    endDate: tableParams.endDate.format("YYYY-MM-DD HH:mm:ss"),
    searchText: tableParams.search,
    sortBy: tableParams.sortBy,
    sortOrder: tableParams.sortOrder,
    page: tableParams.page,
    limit: tableParams.size,
    source: "_agg_1day",
    serviceLines: effectiveServiceLines === "''" ? [] : effectiveServiceLines,
    usageSource: getUsageSource(tableParams),
    ...filterStates,
  };

  clearComponentData();

  getServiceLines(_parameters, false);

  getValidDPOs({dpId: selectedOu?.id })

  getStarlinkLastLocation( {
      dpIds,
      accounts:  effectiveServiceLines === "''" &&  newSummaryServiceAccount?.length === selectedServiceAccount?.length ? []: selectedServiceAccount,
      serviceLines: effectiveServiceLines === "''" ? [] : effectiveServiceLines,
      source: "_agg_1day",
      ...filterStates,
      startDate: moment().startOf("month").format("YYYY-MM-DD HH:mm:ss"),
      endDate: moment().endOf("month").format("YYYY-MM-DD HH:mm:ss"),
      searchText:  tableParams.search,
    },
    false
  );

  return () => {
  };
}, [
  JSON.stringify(tableParams),
  effectiveServiceLines,
  JSON.stringify(selectedServiceAccount),
  selectedFilters,
])


  const handleChangePage = (event: any, newPage: number) => {
    setTableParams({ ...tableParams, page: newPage });
    setSelectedServiceLine(null)
  };

  const handleChangeSize = (event: any) => {
    setTableParams({ ...tableParams, size: event.target.value, page: 1 });
  };

  const handleChangeSorting = (sortBy: DashboardSortBy, sortOrder: SortOrder) => {
    setTableParams({
      ...tableParams,
      sortBy: sortBy,
      sortOrder: sortOrder,
      page: 1
    });
  }

  useEffect(()=>{
    if(selectedServiceLine) {
      setTableWidth(31)
    }

  },[selectedServiceLine])
  
  useEffect(() => {
  if (mapClick === null) return
    if (mapClick === 'empty'){
    getServiceLinesAPI('');
    return;
  }

  if (selectedServiceLine && mapClick.serviceLineNumber) {
    getServiceLinesAPI(mapClick.serviceLineNumber);
  }
  }, [mapClick?.serviceLineNumber])


  const getServiceLinesAPI = (search) =>{
        const filterStates = processFilters(selectedFilters);
    const adjustedSearchText =  search;

    const _parameters = {
      dpIds,
      accounts:  effectiveServiceLines === "''" &&  newSummaryServiceAccount?.length === selectedServiceAccount?.length ? []: selectedServiceAccount,
      serviceLines: effectiveServiceLines === "''" ? [] : effectiveServiceLines,
      startDate: tableParams.startDate.format("YYYY-MM-DD HH:mm:ss"),
      endDate: tableParams.endDate.format("YYYY-MM-DD HH:mm:ss"),
      searchText: adjustedSearchText,
      sortBy: tableParams.sortBy,
      sortOrder: tableParams.sortOrder,
      page: 1,
      limit: tableParams.size,
      source: "_agg_1day",
      usageSource: getUsageSource(tableParams),
      ...filterStates,
    };

    clearComponentData();
    getServiceLines(_parameters);
  }
  const handleDownloadReport = () => {
    const filterStates = processFilters(selectedFilters);
    const params: CsvParameters = {
      type: "QUERY_CH",
      queryName: "OPT_GET_SERVICE_LINES_SPORT_V5",
      id: "starlink-dashboard",
      payload: {
        dpIds: dpIds.map(dpId => `'${dpId}'`).join(','),
        accountNumbers:  effectiveServiceLines === "''" &&  newSummaryServiceAccount?.length === selectedServiceAccount?.length ? "''" : selectedServiceAccount?.map(acc => `'${acc}'`).join(',') ? selectedServiceAccount?.map(acc => `'${acc}'`).join(',') : "''" ,
        serviceLines: effectiveServiceLines === "''" || effectiveServiceLines === null ? "''" : effectiveServiceLines?.map(sl => `'${sl}'`).join(','),
        searchText: tableParams.search,
        sortBy: tableParams.sortBy,
        sortOrder: tableParams.sortOrder,
        source: getSource(tableParams),
        usageSource: getUsageSource(tableParams),
        limit: totalServiceLines,
        offset: 0,
        offlineServiceLines: filterStates?.offlineServiceLines ? filterStates?.offlineServiceLines : false,
        onlineServiceLines: filterStates?.onlineServiceLines ? filterStates?.onlineServiceLines : false,
        noTerminals: filterStates?.noTerminals ? filterStates?.noTerminals : false,
        offlineTerminals: filterStates?.offlineTerminals ? filterStates?.offlineTerminals : false,
        onlineTerminals: filterStates?.onlineTerminals ? filterStates?.onlineTerminals : false,
        alertingTerminals: filterStates?.alertingTerminals ? filterStates?.alertingTerminals : false,
        disableMobilePriority: filterStates?.mobilePriorityDisabled ? filterStates?.mobilePriorityDisabled : false,
        enableMobilePriority : filterStates?.mobilePriorityEnabled ? filterStates?.mobilePriorityEnabled : false,
      },
    };

    downloadAsCSV(params);
  };

  const formatNumber = (value: any, decimals = 2) => typeof value === 'number' ? value.toFixed(decimals) : value;
  const CsvHeaders = ['Deployment', 'Service Line', 'Service Line Number', 'Organization', 'Sub Organization', 'Plan', 'Plan Size', 'Global Priority (GB)', 'Local Priority (GB)', 'Mobile Priority (GB)', 'Other Data (GB)', 'Legacy Data (GB)', 'User Terminal', 'Active Alerts'];

  const mapToCsvRow = (row: any[]) => ([row[39] ?? '', row[7] ?? '', row[0] ?? '', row[4] ?? '', row[6] ?? '', row[13] ?? '', row[8] ?? '', formatNumber(row[24]), formatNumber(row[23]), formatNumber(row[22]), formatNumber(row[26]), formatNumber(row[25]), row[33] ?? '', row[31] ?? '' ]);

  useEffect(() => {
    if (authReducer.csvDataDownloded && authReducer.csvDataDownloded.length > 0) {
      if (authReducer.csvDownloadId === 'starlink-dashboard') {
        if (authReducer.csvDataDownloded && authReducer.csvDataDownloded?.length) {
          const rows = authReducer.csvDataDownloded;
          if (rows.length) {
            DownloadCSV([CsvHeaders,   ...(Array.isArray(rows)
              ? rows?.slice(1)?.map(row => mapToCsvRow?.(row)).filter(Boolean)
              : [])], {
              formatters: {
                0: 'ESC-COMMA',
                1: 'ESC-COMMA',
                2: 'ESC-COMMA',
                3: 'ESC-COMMA',
                5: 'ESC-COMMA',
                6: 'ESC-COMMA',
                12: 'ESC-COMMA',
                13: 'ESC-COMMA',
              }
            }
            );
          }
        }
        return () => {
          dispatch(clearCsvDownload())
        }
      }
    }
  }, [authReducer.csvDataDownloded])

  const handleOnSearchChange = (value: String) => {
    setSearchText(value);
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }
    searchTimeoutRef.current = setTimeout(() => {
      searchTimeoutRef.current = undefined;
      handleSearch(value);
      setSearchOperation(true)
    }, 2000)
  }

  const handleSearch = (value) => {
    setTableParams({
      ...tableParams,
      search: value,
      page: 1
    });
  }

  const handleOpenCard = () => {
    setOpenCards(!openCard)
  }
const multiOptionHeaderLabels = ["Service Lines"];

const multiOptionData = {
  servicelines: defaultFilters.reduce((acc, item) => {
    acc[item.label] = item.name;
    return acc;
  }, {}),
};

const handleMultiOptionChange = (key, value) => {
  const index = filters.findIndex(f => f.label === value);
  if (index !== -1) {
    let updatedFilters = filters.map((f, i) => i === index ? { ...f, selected: !f.selected } : f);
    
    const targetFilter = updatedFilters[index];
    if (targetFilter.selected) {
      if (value === "noTerminals") {
        updatedFilters = updatedFilters.map(f => 
          (f.label === "onlineTerminals" || f.label === "offlineTerminals") ? { ...f, selected: false } : f
        );
      } else if (value === "onlineTerminals" || value === "offlineTerminals") {
        updatedFilters = updatedFilters.map(f => 
          f.label === "noTerminals" ? { ...f, selected: false } : f
        );
      }
    }

    setFilters(updatedFilters);
    const appliedFilters = updatedFilters.filter((filter) => filter.selected);
    setSelectedFilters(appliedFilters);
    setTableParams({ ...tableParams, page: 1 });
  }
};

const getUsageDisplay = (serviceLine) => {
  if (!serviceLine) return '0';

  const isUnlimited =
    serviceLine?.isPooledAccount === true &&
    Number(serviceLine?.usageLimitGB) === 0;

  const hasUnlimitedPlan =
    serviceLine?.isPooledAccount === false &&
    typeof serviceLine?.servicePlan === 'string' &&
    serviceLine.servicePlan.toLowerCase().includes('unlimited');

  if (isUnlimited || hasUnlimitedPlan) return 'Unlimited';

  const usage = Number(serviceLine?.usageLimitGB);
  if (Number.isNaN(usage) || usage < 0) return '0';

  return usage.toFixed(0);
};

const MIN_TABLE_WIDTH = 31;
const MAX_TABLE_WIDTH = 70;
 
const [tableWidth, setTableWidth] = useState(31);
const isDraggingRef = useRef(false);
 
const handleMouseDown = () => isDraggingRef.current = true;
const handleMouseUp = () => isDraggingRef.current = false;
 
const handleMouseMove = (e) => {
  if (!isDraggingRef.current) return;
  const container = document.querySelector('.containerStyleMapOpen,.containerStyleMapClosed');
  if (!container) return;
  const rect = container.getBoundingClientRect();
  const newWidth = ((e.clientX - rect.left) / rect.width) * 100;
  if (newWidth < MIN_TABLE_WIDTH || newWidth > MAX_TABLE_WIDTH) return;
  setTableWidth(newWidth);
};

const handleDoubleClick = () => {
  setTableWidth(prev => prev >= MAX_TABLE_WIDTH ? MIN_TABLE_WIDTH : MAX_TABLE_WIDTH);
};
 
useEffect(() => {
  const onMouseMove = (e) => handleMouseMove(e);
  const onMouseUp = () => handleMouseUp();

  window.addEventListener('mousemove', onMouseMove);
  window.addEventListener('mouseup', onMouseUp);

  return () => {
    window.removeEventListener('mousemove', onMouseMove);
    window.removeEventListener('mouseup', onMouseUp);
  };
}, [handleMouseMove, handleMouseUp]);

 const handleClickSelect = ( value ) => {
        const params: any = getDecodeURI(location.search);
            params.serviceLineAccess = value?.serviceLineNumber;
        
        history.push({ pathname: location.pathname, search: `?${getEncodedURI(params)}` });
    };


  return (
    <div className="starlinkMapContainer">
      
      <TopBar
        height={32}
        showFilter={true}
        multiOptionSelection={true}
        multiOptionData={multiOptionData}
        multiOptionFilters={{
          servicelines: filters.filter(f => f.selected).map(f => f.label),
        }}
        multiOptionHeaderLabels={multiOptionHeaderLabels}
        handleMultiOptionChange={handleMultiOptionChange}
        showSearch={true}
        searchValue={searchText}
        setSearchValue={setSearchText}
        handleOnSearchChange={handleOnSearchChange}
        showDownloadButton={true}
        handleDownloadReport={handleDownloadReport}
        showCardCarrot={true}
        openCard={openCard}
        handleOpenCard={handleOpenCard}
      />

      {openCard &&
        <div >
          <Grid classes={{ root: 'starlink--base--mtb_07x' }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <Card title="Service Lines" leftTitle="Total" leftContent={totalServiceLines} rightTitle="Overage" rightContent={totalOverage} progress={(totalServiceLines - totalOverage) / totalServiceLines * 100} />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <Card title="User Terminals" leftTitle="Total" leftContent={totalUserTerminals}
                  rightTitle="Offline" rightContent={totalUserTerminals - totalOnlineTerminals} progress={totalOnlineTerminals / totalUserTerminals * 100} />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <Card title="Usage" leftTitle="Total" leftContent={`${totalUsageGB} GB`} rightTitle="Overage (MTD)" rightContent={`${totalOverageGB?.toFixed(2)} GB`} progress={(totalUsageGB - totalOverageGB) / totalUsageGB * 100} />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <Card title="Alerts" leftTitle="Total Alerts" leftContent={totalActiveAlerts || 0} rightTitle="Alerting Terminals" rightContent={totalAlertingTerminals || 0} progress={(totalUserTerminals - totalAlertingTerminals) / totalUserTerminals * 100} />
              </Grid>
            </Grid>
          </Grid>
        </div>}

      <div className={openCard ? "containerStyleMapOpen" : "containerStyleMapClosed"}>
          <div className="starlinkMap-Main" style={{ width: `${tableWidth}%` }}>
          <Pagination count={totalServiceLines} onPageChange={handleChangePage} page={tableParams.page} rowsPerPage={tableParams.size} onRowsPerPageChange={handleChangeSize} />
          <TableContainer
            component={Paper}
            className="starlink--table_container strMap-table"
          >
            <Table stickyHeader size="small" aria-label="starlink--dashboard">
              <TableHead>
                <TableRow>
                  <TableCell className="starlink-sl-number">
                    <SortArrows sortBy={tableParams.sortBy} sortOrder={tableParams.sortOrder} field="nickname" onChange={handleChangeSorting}>
                    <div className="starlink-service-line-toggle">
                          <span className="font-wt-900">SERVICE LINE</span>
                          <div
                          onClick={(e) => e.stopPropagation()} 
                          onMouseDown={(e) => e.stopPropagation()} >
                            <Tooltip title="SL Name / SL Number">
                          <Switch size="small"
                              checked={switchServiceLineToggle}
                              onChange={(e) => {  e.stopPropagation();  setSwitchServiceLineToggle(!switchServiceLineToggle) }}
                              inputProps={{ 'aria-label': 'controlled' }}
                          />
                          </Tooltip>
                          </div>
                          </div> 
                    </SortArrows>
                  </TableCell>
                  <TableCell>
                    <SortArrows sortBy={tableParams.sortBy} sortOrder={tableParams.sortOrder} field="usageGB" onChange={handleChangeSorting}>
                      <span className="font-wt-900">USAGE (GB)</span>
                    </SortArrows>
                  </TableCell>
                  <TableCell> <span className="font-wt-900">PLAN (GB)</span></TableCell>
                  <TableCell>  <span className="font-wt-900">STATUS</span> </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {serviceLines?.length > 0 ? (
                  serviceLines?.map((serviceLine: any, index: number) => (
                    <TableRow key={index}   >
                      <TableCell className={`selectedRow ${selectedServiceLine == serviceLine ? "highlight" : ""} `}>
                        <div className="d-flex">
                            <div
                              className="starlinkMap-serviceLine"
                              onClick={() => { 
                                setSelectedServiceLine(serviceLine);
                                handleClickSelect(serviceLine)
                                setMapClick(null) 
                                }}
                                onMouseEnter={()=>{ setHoveredSL(serviceLine)}}
                                onMouseLeave={()=>{ setHoveredSL(null)}}
                            >
                              { switchServiceLineToggle ? serviceLine?.serviceLineNumber : middleEllipsisByWidth(serviceLine?.nickname, tableWidth) }
                            </div>
                        </div>
                      </TableCell>
                       <TableCell className={`selectedRow ${selectedServiceLine == serviceLine ? "highlight" : ""}`}>
                        {serviceLine?.usageGB
                          ?
                            <Grid display={'flex'} alignItems={'center'}>
                              <Box>
                                {`${Math.round(serviceLine?.usageGB || 0)} `}
                              </Box>
                            </Grid>
                          : 0
                        }
                      </TableCell>
                       <TableCell className={`selectedRow ${selectedServiceLine == serviceLine ? "highlight" : ""}`}>
                        {getUsageDisplay(serviceLine)}
                      </TableCell>
                      <TableCell className={`starMap-rows-status selectedRow ${selectedServiceLine == serviceLine ? "highlight" : ""}`}>
                        <div className="starlink-d-flex ">
                          <div>
                            {serviceLine?.is_service_line_paused === false ? (
                              <Tooltip title="Service Line Status: Online" arrow >
                                <div> <CircleIcon id={"greenDotSymbol"} /> </div>
                              </Tooltip>
                            ) : (
                              <Tooltip title="Service Line Status: Offline" arrow  >
                                <div> <CircleIcon id={"greyDotSymbol"} /></div>
                              </Tooltip>
                            )}
                          </div>

                          <div className="str-mr-5 pd-right-1">
                         {serviceLine?.userTerminals  ? JSON.parse(serviceLine?.userTerminals)?.some(t => t.online === "true") ? (
                              <Tooltip title={
                                <>
                                  {
                                    serviceLine.userTerminals !== '' && JSON.parse(serviceLine.userTerminals)?.map((userTerminal: any) => {
                                      return <Grid classes={{ root: 'starlink--base--flex--align--center' }}>
                                        {userTerminal.kitSerialNumber ? <Fragment>
                                          <CircleIcon id={JSON.parse(userTerminal.online) ? "greenDotSymbol" : "redDotSymbol"} />
                                          {userTerminal.kitSerialNumber}
                                        </Fragment> : null}
                                      </Grid>
                                    })
                                  }
                                </>
                              } arrow >
                                <div className="d-flex align-center">
                                  <div> <img src={TerminalIcon}  width="18" height="18" /> </div>
                                  <div>{serviceLine?.userTerminals !== '' && JSON.parse(serviceLine.userTerminals)?.length} </div>

                                </div>
                              </Tooltip>
                            ) : (
                              <Tooltip title={
                                <>
                                  {
                                    serviceLine.userTerminals !== '' && JSON.parse(serviceLine.userTerminals)?.map((userTerminal: any) => {
                                      return <Grid classes={{ root: 'starlink--base--flex--align--center' }}>
                                        {userTerminal.kitSerialNumber ? <Fragment>
                                          <CircleIcon id={JSON.parse(userTerminal.online) ? "greenDotSymbol" : "redDotSymbol"} />
                                          {userTerminal.kitSerialNumber}
                                        </Fragment> : null}
                                      </Grid>
                                    })
                                  }
                                </>
                              } arrow >
                                <div className="d-flex align-center">
                                  <div> <img src={TerminalIconOffline}  width="18" height="18" /></div>
                                  <div>{serviceLine?.userTerminals !== '' && JSON.parse(serviceLine.userTerminals)?.length} </div>
                                </div>
                              </Tooltip>
                            ) : null}
                          </div>

                          <div className="str-mr-5 pd-right-1">
                            {serviceLine?.userTerminals && serviceLine?.userTerminals !== '' && (
                              <Tooltip
                                classes={{ tooltip: 'starlink--tooltip' }}
                                title={serviceLine.userTerminals !== '' ?
                                  <div >
                                    {JSON.parse(serviceLine.userTerminals)?.map((userTerminal: any, index: number) => {
                                      const activeAlerts = JSON.parse(userTerminal.activeAlerts || '[]');
                                      return (
                                        activeAlerts?.length > 0 && (
                                          <Table size="small" key={index}>
                                            <TableBody>
                                              {
                                                activeAlerts?.map((alert: any, alertIndex: number) => (
                                                  <TableRow key={alertIndex}>
                                                    <TableCell>{userTerminal.kitSerialNumber || 'N/A'}</TableCell>
                                                    <TableCell>{alertMap[alert] ? titleCase(alertMap[alert]) : titleCase(`alert_${alert}`)}</TableCell>
                                                  </TableRow>
                                                ))
                                              }
                                            </TableBody>
                                          </Table>
                                        )
                                      );
                                    })
                                    }
                                  </div> : null
                                }
                                arrow
                              >
                                <div className="strMapIcon d-flex align-center">
                                  <div>  <img src={Warning}  width="18" height="18" /></div>
                                  <div className="str-alert">{
                                    serviceLine.userTerminals !== '' &&
                                    JSON.parse(serviceLine.userTerminals)
                                      ?.reduce((total: number, userTerminal: any) => {
                                        const alerts = JSON.parse(userTerminal?.activeAlerts || '[]');
                                        return total + alerts.length;
                                      }, 0)
                                  }</div>
                                </div>
                              </Tooltip>
                            )}
                          </div>

                          <div >
                            {serviceLine?.opted_in ? (
                              <Tooltip title="Mobile Priority: Enabled" arrow >
                                <div>  <img src={OptedIn}  width="18" height="18" /> </div>
                              </Tooltip>
                            ) : (
                              <Tooltip title="Mobile Priority: Disabled" arrow >
                                <div> <img src={OptedOut}  width="18" height="18" />   </div>
                              </Tooltip>
                            )}
                          </div>
                          <div >
                           {Number(serviceLine?.total_topup_limit_gb || 0) > 0 ? (
                              <Tooltip
                                classes={{ tooltip: 'starlink--tooltip' }}
                                title={
                                  <Grid>
                                    <Table size="small">
                                      <TableBody>

                                        <TableRow>
                                          <TableCell classes={{ root: 'starlink--tooltip--value_title' }}>Topup Usage</TableCell>
                                          <TableCell>{Math.round(serviceLine?.total_topup_consumed_gb || 0)} GB</TableCell>
                                        </TableRow>

                                        <TableRow>
                                          <TableCell classes={{ root: 'starlink--tooltip--value_title' }}>Topup Size</TableCell>
                                          <TableCell>{Math.round(serviceLine?.total_topup_limit_gb || 0)} GB</TableCell>
                                        </TableRow>
                                      </TableBody>
                                    </Table>
                                  </Grid>
                                }>
                              <img src={TopupEnabledIcon}
                                  onClick={() => {
                                    if (isValidDpForDPO && !serviceLine?.isPooledAccount) {
                                      setOpenTopUp({ open: true, data: serviceLine })
                                    }
                                  }
                                  }
                                  width="18" height="18" />
                              </Tooltip>
                            ): isValidDpForDPO && !serviceLine?.isPooledAccount ?  <img src={starlinkAddNew}
                                  onClick={() => {
                                    if (isValidDpForDPO && !serviceLine?.isPooledAccount) {
                                      setOpenTopUp({ open: true, data: serviceLine })
                                    }
                                  }
                                  }
                                  width="18" height="18" /> : null}
                             </div>

                        </div>
                      </TableCell>

                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={3} align="center">
                      No service lines available.
                    </TableCell>
                  </TableRow>
                )}

              </TableBody>
            </Table>
          </TableContainer>
        </div>

        {openTopUp.open && <TopUpModal open={openTopUp?.open} onClose={() => { setOpenTopUp({ open: false, data: null }) }} serviceLine={openTopUp?.data} />}

        <div className="resizeHandle"  onDoubleClick={handleDoubleClick} onMouseDown={handleMouseDown}>
          <div className="resizeDots">
            <span /><span /><span /><span /><span /><span />
          </div>
        </div>
 
        <div className="resizableMap" style={{ width: `${100 - tableWidth}%` }}>
        <StarlinkMap
          starlinkLastLocations={starlinkLastLocations}
          serviceLines={serviceLines?.length > 0 && serviceLines}
          selectedServiceLine={selectedServiceLine}
          setSelectedServiceLine={setSelectedServiceLine}
          mapClick={mapClick}
          setMapClick={setMapClick}
          hoveredSL={hoveredSL}
          setHoveredSL={setHoveredSL}
          tableSearch={searchOperation}
          setSearchOperation={setSearchOperation}
          newSummaryServiceLine={newSummaryServiceLine}
          tableWidth={tableWidth}
        />
        </div>
      </div>

    </div>
  );
};

const mapStateToProps = (state) => ({
  authReducer: state.authReducer,
  errorReducer: state.errorReducer,
  dpIds: state.starlinkCloud.dpIds,
  warnings: state.starlinkDashboard.warnings,
  serviceLines: state.starlinkDashboard.serviceLines,
  starlinkLastLocations: state.starlinkDashboard.starlinkLastLocations,
  newSummaryStartDate: state?.authReducer?.newSummaryStartDate,
  newSummaryEndDate: state?.authReducer?.newSummaryEndDate,
  newSummaryServiceLine: state?.authReducer?.newSummaryServiceLine,
  selectedServiceAccount: state?.authReducer?.selectedServiceAccount,
  newSummaryServiceAccount: state?.authReducer?.newSummaryServiceAccount,
  hasUserChangedServiceLine: state?.authReducer?.hasUserChangedServiceLine,
  getSubscribedServiceLines:state?.starlinkDashboard?.getSubscribedServiceLines,
  selectedOu: state?.authReducer?.selectedOu,
  isValidDpForDPO: state?.starlinkAdmin?.isValidDpForDPO

});

export default withRouter(
  connect(mapStateToProps, {
    getServiceLines,
    clearComponentData,
    getStarlinkLastLocation,
    downloadAsCSV,
    getNonAdminPermissions,
    getValidDPOs
  })(StarlinkMapsDashboard)
);